import { request } from '@/shared/api/request'

export const sendSeverity = (data) => {
	return request({ url: `safety/severity/send`, method: 'POST', data: data })
}

export const sendSeverityXml = (data) => {
	return request({ url: `safety/severity/xml`, method: 'POST', data: data })
}

export const sendInvestigation = (data) => {
	return request({ url: `safety/investigation/send`, method: 'POST', data: data })
}

export const sendInvestigationXml = (data) => {
	return request({ url: `safety/investigation/xml`, method: 'POST', data: data })
}

export const sendComission = (data) => {
	return request({ url: `safety/comission/send`, method: 'POST', data: data })
}

export const sendComissionXml = (data) => {
	return request({ url: `safety/comission/xml`, method: 'POST', data: data })
}

export const getInvestigationReport = (id) => {
	return request({ url: `/safety/investigation/report/${id}`, method: 'GET' })
}
